import { getLimitLabel } from "../../Constants";

import Selector from "./Selector";

export const limitTypes = [
  // { title: "No limit", value: -1 },
  { title: "1 month", value: 30 },
  { title: "2 months", value: 61 },
  { title: "3 months", value: 92 },
  { title: "6 months", value: 183 },
  { title: "1 year", value: 366 },
  { title: "2 years", value: 731 },
  { title: "3 years", value: 1096 },
];

export default function LimitSelector({ value, language, onChange }) {
  return (
    <Selector
      options={limitTypes}
      value={value}
      onChange={onChange}
      className="limit"
      getOptionLabel={(option) => getLimitLabel(option.title, language)}
    />
  );
}
